import React, { useState } from "react";
import {
  Form,
  FormCardContainer,
  FormSectionContainer,
  PageTitle,
} from "../style";
import styled from "styled-components";
import TextCenteredInput from "../../../Components/Form/Inputs/TextCenteredInput";
import BigButton from "../../../Components/Form/Buttons/BigButton";
import { changeUserLogin } from "../../../Apis/Auth/Account";
import { toast } from "react-toastify";

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const ChangeStudentEmail = () => {
  const [oldemail, setOldEmail] = useState("");
  const [newemail, setNewEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!oldemail || !oldemail.trim()) {
      toast.error("Please enter current student email");
      return;
    }

    if (!newemail || !newemail.trim()) {
      toast.error("Please enter new student email");
      return;
    }

    setLoading(true);
    try {
      await changeUserLogin(oldemail.trim(), newemail.trim());
      setOldEmail("");
      setNewEmail("");
    } catch (error) {
      // Error toast handled inside changeUserLogin
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle>Change Student Email</PageTitle>
      <FormSectionContainer>
        <FormCardContainer style={{ maxWidth: "600px" }}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <FormField>
              <TextCenteredInput
                alignText="left"
                type="email"
                placeholder="Enter email of student you wish to change"
                name="oldemail"
                value={oldemail}
                onChangeHandler={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setOldEmail(e.target.value)
                }
              />
            </FormField>

            <FormField>
              <TextCenteredInput
                alignText="left"
                type="email"
                placeholder="Enter the new email of student you wish change to"
                name="newemail"
                value={newemail}
                onChangeHandler={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setNewEmail(e.target.value)
                }
              />
            </FormField>

            <BigButton
              buttonText="Submit"
              disabled={loading}
              loading={loading}
              handleClick={handleSubmit}
            />
          </Form>
        </FormCardContainer>
      </FormSectionContainer>
    </>
  );
};

export default ChangeStudentEmail;
